<template lang="pug">
#map-splitter.absolute.absolute--fill
    #rightmap.absolute.absolute--fill
    #leftmap.absolute.absolute--fill

    .mapboxgl-ctrl-group.mapboxgl-ctrl#share-template(style="margin-top: 1em")
        button.mapbox-gl-ctrl-icon(@click="clickShare" style="background-image: url(./noun_Share_162946.png) !important; background-size: 2.5em; width:2.5em; height:2em;" title="Share map" aria-label="Share map")
</template>

<script>
// import mapboxgl from 'mapbox-gl';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl-dev';
import Compare from 'mapbox-gl-compare';
// monkey-patch missing event fire
// see https://github.com/mapbox/mapbox-gl-compare/pull/35
Compare.prototype._onTouchEnd = function () {
    document.removeEventListener('touchmove', this._onMove);
    document.removeEventListener('touchend', this._onTouchEnd);
    this.fire('slideend', { currentPosition: this.currentPosition });
};
import U from 'mapbox-gl-utils';
import { EventBus } from '../EventBus';
import axios from 'axios';
import chroma from 'chroma-js';
window.chroma = chroma;
let countryLabels = {};
import {
    layers,
    makeHighlightLayers,
    highlightRegion,
    interactiveLayers,
} from './layers';
import { addGeocoder, clearGeocoder } from './geocoder';

window.app.layers = layers;
import * as Layers from './layers';
window.Layers = Layers;

import {
    fitBoundsPadding,
    selectRegion,
    loadIndex,
    getRegionIndex,
} from './utils';

function makeSatelliteMap(map) {
    for (const layer of map.getStyle().layers) {
        if (!(layer['source-layer'] || '').match(/_(top|middle|sbrgns)/)) {
            map.U.hide(layer.id);
        }
    }
    map.U.show('mapbox-satellite');
    map.U.setRasterOpacity('mapbox-satellite', 1);
}

async function loadCountries() {
    countryLabels = (await axios.get('country-labels.geojson')).data;
}

function zoomToSingleRegion(feature) {
    const bbox = indexForRegion(feature).properties._bbox;
    window.leftmap.fitBounds(bbox, {
        padding: fitBoundsPadding(),
    });
    if (window.geocoder.mapMarker) {
        window.geocoder.mapMarker.remove();
    }
}

function zoomToCountry(feature) {
    // debugger;
    const country = countryLabels.features.find(
        (f) => f.properties.ADMIN === feature.properties.name_en
    );
    if (!country) {
        console.log(
            `Can't find country matching ${feature.properties.name_en}`
        );
        return;
    }
    const bbox = country.properties._bbox;
    window.leftmap.fitBounds(bbox, {
        padding: fitBoundsPadding(),
    });
    if (window.geocoder.mapMarker) {
        window.geocoder.mapMarker.remove();
    }
}

function bothMaps(func, ...args) {
    window.leftmap[func](...args);
    if (window.rightmap) {
        window.rightmap[func](...args);
    }
}

function bothMapsU(func, ...args) {
    window.leftmap.U[func](...args);
    if (window.rightmap) {
        window.rightmap.U[func](...args);
    }
}

function indexForRegion(regionFeature) {
    const rf = regionFeature.properties;
    const idx = getRegionIndex().find(
        (f) =>
            f.properties.Name_rgn === rf.Name_rgn &&
            f.properties.class === rf.class
    );
    if (!idx) {
        console.log(
            `Couldn't find index for region: Name_rgn ${rf.Name_rgn}, class: ${rf.class}`
        );
    }
    return idx;
}

// function zoomForRegion(regionFeature) {
//     const idx = regionIndex.find(
//         (f) =>
//             f.properties.Name_rgn === regionFeature.properties.Name_rgn &&
//             f.properties.class === regionFeature.properties.class
//     );
//     return idx.tippecanoe.minzoom + 4;
// }

export default {
    async mounted() {
        const viewProvided = window.location.hash.match(/view=/);

        mapboxgl.accessToken =
            'pk.eyJ1IjoibWFydGludm9ud3lzcyIsImEiOiJ5UDZqNzlRIn0.C2v_MaFow7-hiueBnq2ELQ';
        const europeBounds = [
            [-6.797, 39.5577],
            [42.392, 56.49],
        ];
        // const style = 'martinvonwyss/ckm1hksu5010k17s1xtcr6w8q';
        const style =
            'martinvonwyss/ckmlvgu8djvdi17tfcr5o8moc/draft' +
            `?random=${Math.random()}`; // 'cleanup'

        const leftmap = new mapboxgl.Map({
            container: 'leftmap',
            bounds: europeBounds,
            style: `mapbox://styles/${style}`,
            // touchPitch: false,
            // dragRotate: false,
            hash: 'view',
        });
        U.init(leftmap, mapboxgl);
        const splitterMode =
            window.location.hash.match(/splitter=(\w+)/) &&
            window.location.hash.match(/splitter=(\w+)/)[1];
        const rightMode = window.location.hash.match(/choro/)
            ? 'choro'
            : 'satellite';
        let rightmap, splitter;
        if (splitterMode) {
            rightmap = new mapboxgl.Map({
                container: 'rightmap',
                // center: [140, -30],
                // zoom: 4,
                bounds: europeBounds,
                style: {
                    choro: 'mapbox://styles/martinvonwyss/cka4uhw590hhu1io7l5wld1ip',
                    satellite:
                        'mapbox://styles/martinvonwyss/cjwjyc3tt096t1cpnqku9h00z',
                }[splitterMode],
                hash: 'view',
            });
            splitter = new Compare(leftmap, rightmap, '#map-splitter', {});
            window.splitter = splitter;
            splitter.setSlider(
                0.8 *
                    document.getElementById('map-splitter').getClientRects()[0]
                        .width
            );
            splitter.on('slideend', () => {
                const maxPos =
                    leftmap.getContainer().getClientRects()[0].width - 30;
                if (splitter.currentPosition < 30) {
                    splitter.setSlider(30);
                } else if (splitter.currentPosition > maxPos) {
                    splitter.setSlider(maxPos);
                }
            });

            U.init(rightmap, mapboxgl);
        }
        window.map = leftmap;
        window.leftmap = leftmap;
        window.rightmap = rightmap;
        window.app.Map = this;
        if (splitterMode === 'satellite') {
            rightmap.U.onLoad(() => makeSatelliteMap(rightmap));
        }
        const map = leftmap;
        bothMaps('addControl', new mapboxgl.NavigationControl(), 'top-right');
        bothMaps('on', 'move', () => (window.app.App.shareOpen = false));
        bothMaps('on', 'click', () => (window.app.App.shareOpen = false));
        leftmap.U.onLoad(() => {
            makeHighlightLayers(window.leftmap);
            // map.U.hide('smallscale');
            // console.log('hiding smallscale');
        });
        leftmap.once('load', () => {
            if (!viewProvided) {
                bothMaps('fitBounds', europeBounds, { animate: false });
            }
        });
        bothMaps(
            'addControl',
            {
                onAdd: (map) => {
                    return document.querySelector('#share-template');
                },
            },
            'top-right'
        );
        if (rightmap) {
            rightmap.U.onLoad(() => makeHighlightLayers(window.rightmap));
        }
        await loadIndex();
        loadCountries().then();
        addGeocoder(leftmap, mapboxgl.accessToken);

        bothMapsU('hoverPointer', interactiveLayers);
        bothMapsU(
            'clickOneLayer',
            interactiveLayers,
            (e) => {
                if (e.layer === 'wine country lbl') {
                    zoomToCountry(e.features[0]);
                } else {
                    selectRegion(e.features[0]);
                    zoomToSingleRegion(e.features[0]);
                }
                clearGeocoder();
            },
            (e) => {
                selectRegion(null);
                clearGeocoder();
            }
        );
        bothMaps('on', 'dragstart', () => {
            selectRegion(null);
            clearGeocoder();
        });
        bothMaps('on', 'wheel', (e) => {
            clearGeocoder();
        });
        EventBus.$on('clear-feature', () => selectRegion());
    },
    methods: {
        clickShare() {
            window.app.App.shareOpen = !window.app.App.shareOpen;
        },
    },
};
import 'mapbox-gl/dist/mapbox-gl.css';
import 'mapbox-gl-compare/dist/mapbox-gl-compare.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
</script>

<style>
.topLabels,
.midLabels,
.subregionLabels {
    /* font-weight: bold; */
    color: hsl(340, 80%, 30%);
}

.region-title {
    font-weight: bold;
    font-size: unset;
}
/* .topLabels {
    color: hsl(22, 71%, 69%);
}

.midLabels {
    color: hsl(308, 68%, 31%);
}

.subregionLabels {
    color: hsl(0, 58%, 50%);
} */

.class-field {
    /* font-size: 80%; */
    font-style: italic;
}

.state-country {
    /* font-size: 80%; */
    font-weight: normal;
}

.mapboxgl-ctrl-geocoder {
    /* font-size: 32px !important; */
    /* max-width: 340px !important; */
    width: 340px;
    font-family: 'DIN';
}
.mapboxgl-ctrl-geocoder--input {
    /* padding-top: 24px; */
    /* padding-bottom: 24px; */
}

.mapboxgl-compare {
    z-index: 0;
}

.mapboxgl-compare .compare-swiper-vertical {
    /* Remember to update this for whatever final URL */
    background-image: url(../assets/climate-zones.png) !important;
    background-size: cover;
}

.share-button {
    background: white;
    /* border: 1px solid grey; */
    width: 3em;
    height: 2em;
    /* background-size: cover; */
    background-size: 2.5em;
    /* background-image: url(../assets/noun_Share_162946.png) !important; */
    background-image: url(/public/noun_Share_162946.png) !important;
    /* background-image: url(https://mapswell.site44.com/images/wwr/noun_Share_162946.svg) !important; */
}
.share-group {
    margin-top: 1em;
}
</style>
